<div
  (click)="selectError(activeError.id)"
  class="error-container flex flex-row justify-between items-start"
  [class.tile-active]="activeError.isSelected"
>
  <div class="flex flex-col gap-[8px] flex-[100%] max-w-[100%]">
    <div class="flex flex-row justify-between items-center">
      <div class="error-description">
        {{ activeError.errorDescription }}
      </div>
      <app-pill data-at-error-code [type]="pillType.brand">
        {{ activeError.errorCode }}
      </app-pill>
    </div>
    <div class="flex flex-row justify-start items-center">
      <div class="date">{{ installationLocalTimeOfErrorAppearedAt | date: 'short' }}</div>
    </div>
  </div>
</div>
